import { render, staticRenderFns } from "./EditDefaultRights.vue?vue&type=template&id=1a973972&"
import script from "./EditDefaultRights.vue?vue&type=script&lang=ts&"
export * from "./EditDefaultRights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports